__turbopack_context__.v({
  "container": "Section-module__9JLE0a__container",
  "description": "Section-module__9JLE0a__description",
  "nUpCtaDesktop": "Section-module__9JLE0a__nUpCtaDesktop",
  "nUpCtaMobile": "Section-module__9JLE0a__nUpCtaMobile",
  "rounded": "Section-module__9JLE0a__rounded",
  "superTitle": "Section-module__9JLE0a__superTitle",
  "titleRow": "Section-module__9JLE0a__titleRow",
});
